import { useState } from 'react';
import { Outlet, Link } from "react-router-dom";
import txt_white from '../images/txt_white.png';
import home from '../images/home.png';
import tractor from '../images/tractor.png';
import ticket from '../images/ticket.png';
import settings from "./settings.svg";
import home_ from "./home_.svg";
import stocks from "./stocks.svg";
import appstore from "./appstore.svg";
import discord from "./discord.svg";
import { useWeb3React } from "@web3-react/core";
import { injectedProvider } from "./wallet-connector";
import { useEffect, useRef } from "react";
import Jazzicon from "@metamask/jazzicon";
import styled from "@emotion/styled";

const Layout = (passweb) => {

    var {
    account,
    activate,
    active,
    chainId,
    connector,
    deactivate,
    error,
    provider,
    setError
    } = useWeb3React();

    const [etherBalance_, setEtherBalance_] = useState("");
    const [eBalance0__, setEth_balance_] = useState("");
    const [eBalance0_raw_, setEth_balance_raw_] = useState("");

    const boot = async() => {
        document.getElementsByClassName("bg-video")[0].style.display="none";
        document.getElementsByClassName("sectionn")[0].style.display="none";

    }
    const mobnav = async() => {
          var x = document.getElementsByClassName("pageLinks");
          if (x[0].style.display === "block") {
            x[0].style.display = "none";
          } else {
             x[0].style.display = "block";
            }
    }

    const styling = async() => {
      document.getElementsByClassName("bg-video")[0].style.display="none";
      document.getElementsByClassName("sectionn")[0].style.display="none";

      boot();
    }

    const StyledIdenticon = styled.div`
      height: 3rem;
      width: 3rem;
      border-radius: 1.5rem;
      background-color: black;
      margin-top: 1.1%;
      margin-right: 4%;
      float: right;
      `;
  
    var reff = useRef("<HTMLDivElement>");

    useEffect(() => {
      const hourglass = async () => {
  var a;
  a = document.getElementById("div1");
  a.innerHTML = "&#xf251;";
  setTimeout(function () {
      a.innerHTML = "&#xf252;";
    }, 1000);
  setTimeout(function () {
      a.innerHTML = "&#xf253;";
    }, 2000);
};
hourglass();
setInterval(hourglass, 3000);
if(account && reff.current) {
      reff.current.innerHTML = "";
      reff.current.appendChild(Jazzicon(48));
    }
      
      }, [etherBalance_]);


    const showIcon_ = async () => {reff.current.appendChild(Jazzicon(48));}

    const handleConnect = async () => {
      if (typeof window.ethereum !== 'undefined') {
          console.log('MetaMask is installed!');
          await activate(injectedProvider);
          let { provider } = await injectedProvider.activate();
          let web3 = new passweb.webtype(provider); 
          if(typeof window.ethereum!=='undefined' && active) {document.getElementsByClassName("walletbutton")[0].className += " format";}
          document.getElementsByClassName("jazzicon")[0].className += " jazziconn";
          
            //reff.current.innerHTML = "";
          const accounts = await web3.eth.getAccounts();
          let eBalance = await web3.eth.getBalance(accounts[0]);
          let eBalance0=parseInt(eBalance)/1e18;
          //setResp_raw(resp2);
          setEth_balance_raw_(parseInt(eBalance))
          setEth_balance_(eBalance0);
          //setResp_(parseInt(resp2));
          eBalance0 = eBalance0.toFixed(5);
          setEtherBalance_(eBalance0);
          if(window.ethereum.networkVersion!=369) {
              alert("connect to Pulsechain network !");
        }
          //reff.current.appendChild(Jazzicon(48));        
      }


      else alert("install MetaMask");
    
  }


  return (
  <>
   <div className="App">
   <div className="background-img"></div>
    <div className="sectionn"></div>
    <div className="top-bar"><h2>bubble R</h2><a href="https://discord.gg/J7tbKTu3" className="discord_link" target="_blank">Join Chat<img className="discord" src={discord}></img></a>
      <Link to="/"><div id="div1" className="fa"></div></Link>
      <div className="pageLinks">
        <div><a href="#"></a></div>
        <div><a href="#"></a></div>
        <div><a href="#"></a></div>        
        <div><a href="#"></a></div>
      </div>
      <a href="#" className="icon" onClick={mobnav}>
        <i className="fa fa-bars"></i>
      </a>
      <div className="profile-div"><a href="#" onClick={handleConnect} className="walletbutton"><StyledIdenticon className="jazzicon" ref={reff}/></a>
      <span className="account-label" onClick={handleConnect}>{account? `${account.slice(0, 6)}...${account.slice(
              account.length - 4,
              account.length
            )}`:"Click here to connect wallet"}<br/>PLS balance: {active?etherBalance_:"0.000"}</span></div>
    </div>
    <div className="side-bar">
      <ul>
        <li className="side-content" onClick={boot}><Link to="/Home"><img src={home_}></img> <span>Home</span></Link></li>
        <li className="side-content"><Link to="/Fountain"><img src={stocks}></img> <span>Factory</span></Link></li>
        <li className="side-content"><Link to="/Reservoir"><img src={settings}></img> <span>Reservoir</span></Link></li>
        <li className="side-content"><a href="https://pulsechain.com" target="_blank"><img src={appstore}></img> <span>Pulse apps</span></a></li>
    </ul>
    </div>
    <div className="home-bar">
      <ul>
        <li className="side-content" onClick={boot}><Link to="/Home"><img src={home_}></img> <span>Home</span></Link></li>
        <li className="side-content"><Link to="/Fountain"><img src={stocks}></img> <span>Factory</span></Link></li>
        <li className="side-content"><Link to="/Reservoir"><img src={settings}></img> <span>Reservoir</span></Link></li>
        <li className="side-content"><a href="https://pulsechain.com" target="_blank"><img src={appstore}></img> <span>Pulse apps</span></a></li>
    </ul>
    </div>
  <Outlet />

  </div>
  <div className="bg-video">
        
  </div>
  
</>
  )
};

export default Layout;